import { useSetPosOrderSessionData } from "@/shared/atoms/usePosOrderTableSessionAtoms";
import { destroy2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { errorToast } from "@/shared/utils/helpers";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useOrderSessionDeleteMutation = () => {
  const { t } = useTranslation();
  const branchId = useBranchId();
  const setPosOrderSessionData = useSetPosOrderSessionData();

  const mutation = useMutation({
    mutationFn: (orderSessionId: number[]) =>
      destroy2(`/internal/secure/pos/v1/order/sessions/${branchId}`, {
        data: orderSessionId,
      }),
    onSuccess: () => {
      setPosOrderSessionData(null);
      toast.success(t("success.delete"));
    },
    onError: () => {
      errorToast();
    },
  });

  return mutation;
};

export default useOrderSessionDeleteMutation;
